import { UserRoleConsts } from 'client/util/Constants';
import { get } from 'lodash';
import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class CommandRunnerApi extends CollectionApi {
  constructor() {
    super('/api/users', {
      skip: 0,
      limit: 50,
      sort: 'email', // Prepend with a '-' to reverse default sort direction
      search: {
        fields: [
          'email',
        ],
        searchTerm: '',
      },
    });
    this.baseUrl = '/api/users';
  }

  async fetch(skip, limit, sort, searchTerm, cancelToken, filters) {
    return super.fetch(skip, limit, sort, searchTerm, cancelToken, filters)
      .then(items => {
        const results = items.results.filter(
          item => {
            const isCommandRunner = item.roleName.indexOf(UserRoleConsts.commandRunner) !== -1;
            const isTestUser = item.email.indexOf('blackhole+') !== -1;
            return isCommandRunner || isTestUser;
          },
        );

        return {
          totalCount: results.length,
          results,
        };
      });
  }

  fetchAll(searchTerm, boundItems, filters) {
    return super.fetchAll(searchTerm, boundItems, filters)
      .then(items => {
        const results = items.filter(
          item => item.roleName.indexOf(UserRoleConsts.commandRunner) !== -1,
        );
        return new Promise(resolve => resolve(results));
      });
  }

  /**
  * Override the getBoundItemCount method so we can get the total count of command
  * runners from the commandRunner array returned on GET /api/commands/<id>
  *
  * Remove when the associations endpoint is modified to allow binding commands to users
  */
  getBoundItemCount(url) {
    const params = {
      limit: 1,
      skip: 0,
    };

    return this
      .initialize()
      .then(() => axios.get(`${url}?${this.param(params)}`))
      .then((resp) => {
        const commandRunners = get(resp, 'data.commandRunners', []);
        return commandRunners.length;
      });
  }
}

export default new CommandRunnerApi();
